import React from 'react'
import { Navigate, useNavigate, useParams } from 'react-router-dom'
import useSWR from 'swr'

import Loading from '../../components/layout/Loading'
import { getCheckoutUrl } from '../../../api/payment'
import { useAuth } from '../../../libraries/auth'
import FormGroup from '../../components/form/FormGroup'
import TextInput from '../../components/form/TextInput'
import { useI18N } from '../../../libraries/i18n/hook'
import ErrorMessage from '../../components/errors/ErrorMessage'
import BloomLogo from '../../../assets/bloom-logo.svg?react'
import Button from '../../components/form/Button'

const CheckoutPage = () => {
  const { productSlug, email } = useParams()
  const { t } = useI18N()
  const { isAuthenticated, isLoading: isLoadingUser } = useAuth()
  const navigate = useNavigate()
  const [email1, setEmail1] = React.useState<string>('')
  const [email2, setEmail2] = React.useState<string>('')
  const [emailError, setEmailError] = React.useState<string>('')
  if(!productSlug) return <div>Invalid product slug</div>

  const { data, isLoading, error } = useSWR(
    isAuthenticated ? `checkout/${productSlug}` : email ? `checkout/${productSlug}/${email}` : null,
    isAuthenticated || email ? () => getCheckoutUrl({ productSlug, email }) : null
  )

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if(email1 !== email2) {
      setEmailError(t('auth.email.mismatch'))
      return
    }
    navigate(`/checkout/${productSlug}/${encodeURIComponent(email1)}`)
  }

  if(isLoading || isLoadingUser) { return <Loading size='fill-container' /> }
  if(error) { return <div>Error loading checkout page. {error?.message}</div> }

  if(!isAuthenticated && !email) {
    return (
      <div className='p-4 h-screen flex flex-col justify-center items-center'>
        <div className='flex justify-center items-center mb-12 flex-col gap-8'>
          <BloomLogo className='logo h-12 w-auto' />
        </div>
        <form onSubmit={handleSubmit} className='w-full max-w-md flex flex-col'>
          <TextInput
            label={t('auth.login.username')}
            placeholder={t('auth.login.username')}
            onChange={(e) => setEmail1(e.target.value?.trim())}
            required
            className='w-full border border-gray-600'
            type='email'
          />
          <FormGroup>
            <TextInput
              label={t('auth.email.again')}
              placeholder={t('auth.email.again')}
              onChange={(e) => setEmail2(e.target.value?.trim())}
              required
              className='w-full border border-gray-600'
              type='email'
            />
          </FormGroup>
          <Button type='submit'>
            {t('common.continue')}
          </Button>
          {emailError && <ErrorMessage error={new Error(emailError)} />}
        </form>
      </div>
    )
  }
  if(!data) { return <div>Empty checkout url</div> }
  if(data.startsWith('http')) {
    // external page
    window.location.replace(data)
  }  else {
    // internal page
    return <Navigate to={data} replace />
  }
  return <Loading size='fill-container' />
}

export default CheckoutPage
